// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__37IZz","spin":"Loader_spin__uya7z","default":"Loader_default__2jS_d","secondary":"Loader_secondary__v3NEq"};